// extracted by mini-css-extract-plugin
export default {"Config":"Config_Config__+ixjl","Main":"Config_Main__S3WVz"};